<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    @if (vm.maalerOplysninger?.maalerNr) {
      <servicerapport-maaler-oplysninger [data]="vm.maalerOplysninger">
      </servicerapport-maaler-oplysninger>
    }
    @if (vm.opgaver.length) {
      <div>
        <h2>Tilgængelige opgaver</h2>
        <mat-list class="mat-elevation-z2">
          @for (opgave of vm.opgaver; track opgave) {
            <mat-list-item>
              <h3 matListItemTitle>{{ opgave.navn }}</h3>
              @if (erIgangvaerende$(opgave.id) | async) {
                <div matListItemLine>
                  <button mat-button type="button" color="warn" (click)="onAnnullerClick(opgave.id)">ANNULLER</button>&ngsp;
                  <button mat-flat-button type="button" class="start" color="primary" (click)="onStartClick(opgave.id)">
                    GENOPTAG
                  </button>
                </div>
              } @else {
                <div matListItemLine>
                  <button mat-flat-button type="button" class="start" color="primary" (click)="onStartClick(opgave.id)">
                    START
                  </button>
                </div>
              }
              <mat-divider></mat-divider>
            </mat-list-item>
          }
        </mat-list>
      </div>
    } @else {
      <empty-page-badge svgIcon="emoticon-sad-outline" overskrift="Ingen opgaver">
        <p>Der er ikke nogen opgaver tilgængelig.</p>
      </empty-page-badge>
    }
  }
</dff-side>
